<template>
  <router-view></router-view>
</template>
<script>

import prefetchService from '@/services/prefetch'

export default {
  mounted () {
    if (this.$store.state.auth.authenticated) {
      prefetchService()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/app.vue